<template>
  <div class="pb-2">
    <header class="h2 text-secondary mb-4">
      Filter:
    </header>
    <main class="flex flex-wrap">
      <section class="flex flex-col w-full md:w-1/2 lg:w-2/6 mr-0 md:mr-4 mb-4">
        <tag-select-box
          v-model="filters.kwalificaties"
          :tags="kwalificaties"
          item-key="title"
        />
      </section>

      <section class="flex flex-wrap">
        <select-box
          v-if="doelgroepen"
          v-model="filters.doelgroep"
          filter-bar
          label="Doelgroep:"
          class="mr-4 mb-4"
          :options="doelgroepen"
          return-object
          option-text-key="title"
        />

        <!--
        <select-box
          v-if="locaties"
          v-model="filters.locatie"
          filter-bar
          :options="locaties"
          label="Locatie:"
          class="mr-4 mb-4"
        />
        <select-box
          v-model="filters.bereik"
          :options="bereikOpties"
          return-object
          option-text-key="text"
          filter-bar
          label="Bereik:"
          class="mr-10 mb-4"
        />-->
      </section>

      <section class="flex flex-col text-sm mb-4">
        <div class="font-bold mb-3">
          Weergave:
        </div>
        <div class="flex">
          <button v-for="layout in layouts" :key="layout.name" :class="layout.name === selectedLayout ? 'text-secondary' : ''" class="mr-4 hover:text-secondary transition duration-300" @click="$emit('layout-changed', layout.name)">
            <font-awesome-icon :icon="layout.icon"/>
            {{ layout.name }}
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import SelectBox from '~/components/forms/SelectBox';
import TagSelectBox from '~/components/forms/TagSelectBox';
import doelgroepen from '~/graphql/queries/doelgroepen';
import kwalificaties from '~/graphql/queries/kwalificaties';
import locaties from '~/graphql/queries/locaties';

export default {
  components: {SelectBox, TagSelectBox},
  props: {
    selectedLayout: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    filters: {
      doelgroep: null,
      kwalificaties: null,
      locatie: null,
    },
    bereikOpties: [
      {text: '5km', value: 5},
      {text: '10km', value: 10},
      {text: '15km', value: 15},
      {text: '20km', value: 20},
      {text: '25km', value: 25},
    ],
    layouts: [
      {name: 'Grid', icon: ['fas', 'th-large']},
      {name: 'Kaart', icon: ['fas', 'map-marker-alt']},
    ],
  }),
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit('input', this.filters);
      },
    },
  },
  apollo: {
    doelgroepen: {
      query: doelgroepen,
    },
    kwalificaties: {
      query: kwalificaties,
    },
    locaties: {
      query: locaties,
    },
  },
};
</script>
